import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import "../../styles/DashboardHome.css";
import "../../styles/Tables.css";
import { fetchEmsReadinessApi } from "../../lib/api";

function fmtPct(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0.0%";
  return `${n.toFixed(1)}%`;
}

function formatStatus(value) {
  const status = String(value || "").trim();
  if (!status) return "-";
  return status.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export default function EMSReadiness() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const resp = await fetchEmsReadinessApi();
      setData(resp || null);
    } catch (err) {
      toast.error(err?.message || "Failed to load EMS readiness");
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const modules = useMemo(() => (Array.isArray(data?.modules) ? data.modules : []), [data]);

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <div>
          <h1>EMS Readiness</h1>
          <p className="subtitle">Cross-module readiness snapshot for your ISO 14001 records.</p>
        </div>
      </div>

      <div className="summary-row">
        <div className="kpi-card">
          <div className="kpi-label">Overall completion</div>
          <h2>{loading ? "-" : fmtPct(data?.overall_completion_pct)}</h2>
          <div className="kpi-sub">Average across EMS modules</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-label">Total records</div>
          <h2>{loading ? "-" : Number(data?.total_records || 0)}</h2>
          <div className="kpi-sub">All module entries combined</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-label">Open items</div>
          <h2>{loading ? "-" : Number(data?.total_open_items || 0)}</h2>
          <div className="kpi-sub">Items not yet in completion status</div>
        </div>
      </div>

      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>Module</th>
              <th>Record status</th>
              <th>Total</th>
              <th>Complete</th>
              <th>Open</th>
              <th>Completion</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="table-empty">Loading...</td></tr>
            ) : modules.length === 0 ? (
              <tr><td colSpan={6} className="table-empty">No readiness data yet.</td></tr>
            ) : (
              modules.map((m) => (
                <tr key={m.key || m.name}>
                  <td>{m.name || "-"}</td>
                  <td>{formatStatus(m.record_status)}</td>
                  <td>{Number(m.total || 0)}</td>
                  <td>{Number(m.complete || 0)}</td>
                  <td>{Number(m.open || 0)}</td>
                  <td>{fmtPct(m.completion_pct)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
